define('vspot-angular/resources/job-assignment-resource',[], function () {
    'use strict';

    return ['$resource', function ($resource) {
        return $resource('/api/jobassignments/:controller/:id',
            {
                id: '@id',
                controller: '@controller'
            }, {
                requestSwap: {
                    method: 'POST',
                    params: {
                        controller: 'request_swap',
                    }
                },
                createJobAssignment: {
                    method: 'POST',
                    params: {
                        controller: 'create',
                    }
                },
                updateJobAssignment: {
                    method: 'PUT',
                    params: {
                        controller: 'update',
                    }
                }
            }
        )
    }]
});
